<!--
   Created by qing on 2020/12/18
   Des: 
-->
<template>
  <div class="mix-form-node-list-page" v-if="mixFormInfo" v-wechat-title="titleInfo.title">
    <div class="header">
      <i class="iconfont icon-cengji1"></i>
      <div class="info">
        <div class="name">
          {{mixFormInfo.mixFormName}}
        </div>
        <div v-if="mixFormInfo.handlePermission" class="detail" @click="onClickMixFormDetail">
          详情
        </div>
      </div>
      <div class="last">
        <div v-if="mixFormInfo.archived" class="archived-icon">
          <i class="iconfont icon-icon_submit"></i>
        </div>
        <van-icon v-if="mixFormInfo.handlePermission" name="add-o" @click="onClickAddItem"/>
      </div>
    </div>
    <div class="content" v-if="nodeList.length">
      <div
        class="node-item"
        v-for="node in nodeList"
        :key="node.nodeId"
        @click="onClickNode(node)">
        <div class="color" :style="{backgroundColor: node.nodeColor}"></div>
        <div class="node-name">
          {{node.nodeName}}
        </div>
        <van-icon name="arrow"/>
      </div>
    </div>

    <div v-else class="empty-data-container" style="height: calc(100% - 60px)">
      <img src="../../../assets/images/empty.png" alt="">
      暂无内容
      <el-button type="text" @click="onClickAddItem">现在去创建一个目录</el-button>
    </div>

    <node-list-popup
      ref="nodeListPopup"
      :titleInfo="titleInfo"
      :chargeUserConfig="chargeUserConfig"
      :participantConfig="participantConfig"
      :stackList="stackList"
      :mixFormInfo="mixFormInfo"
      :mixFormId="$route.query.mixFormId"
      @deleteNodeComplete="deleteNodeComplete"
      @close="nodeListPop"
    ></node-list-popup>


    <!--项目详情-->
    <van-popup
      class="mix-form-detail-popup"
      v-model="mixFormConfig.visible"
      :overlay="false"
      get-container="body"
      :style="{ height: '100%', width: '100%' }"
      @close="nodeListPop"
      position="right">

      <div style="margin-top: 10px">
        <van-field :label="$store.getters.mix_form_name">
          <template #input>
            <div>
              {{mixFormInfo.mixFormName}}
            </div>
          </template>
        </van-field>
        <van-field label="分组">
          <template #input>
            <div>
              {{mixFormInfo.groupNames}}
            </div>
          </template>
        </van-field>
        <van-field label="创建人">
          <template #input>
            <div v-if="$store.getters.userListMap[mixFormInfo.userId]">
              {{$store.getters.userListMap[mixFormInfo.userId].nickname}}
            </div>
            <div v-else-if="$store.getters.extMap[mixFormInfo.userId]">
              {{$store.getters.extMap[mixFormInfo.userId]['orgUserName']}}
            </div>
          </template>
        </van-field>
        <van-field label="创建时间">
          <template #input>
            <div>
              {{actionFormatTime(mixFormInfo.createTime)}}
            </div>
          </template>
        </van-field>
      </div>

      <van-field label="负责人" style="margin-top: 10px">
        <template #input>
          <div>
            {{chargeUserName}}
          </div>
        </template>
      </van-field>

      <van-field label="参与人" style="margin-top: 10px">
        <template #input>
          <div>
            {{participant}}
          </div>
        </template>
      </van-field>

      <div class="footer">
        <div class="btn-item" @click="editMixForm">
          <van-icon
            size="22"
            name="edit">
          </van-icon>
          <div>编辑</div>
        </div>
        <div class="btn-item" @click="topMixForm">
          <van-icon
            v-if="mixFormInfo.top"
            size="22"
            name="down"/>
          <van-icon
            v-else
            size="22"
            name="back-top">
          </van-icon>
          <div>{{mixFormInfo.top ? '取消置顶' : '置顶'}}</div>
        </div>
        <div v-if="[mixFormInfo.userId, mixFormInfo.chargeUser].includes($store.getters.userId)" class="btn-item" @click="archivedMixForm">
          <van-icon
            size="22"
            name="debit-pay">
          </van-icon>
          <div>{{mixFormInfo.archived ? '启用' : '归档'}}</div>
        </div>
        <div v-if="[mixFormInfo.userId, mixFormInfo.chargeUser].includes($store.getters.userId)" class="btn-item" style="color: red" @click="deleteMixForm">
          <van-icon
            size="22"
            name="delete">
          </van-icon>
          <div>删除</div>
        </div>
      </div>
    </van-popup>


    <!--项目编辑-->
    <add-mix-form-popup
      ref="addMixFormPopup"
      :stackList="stackList"
      :chargeUserConfig="chargeUserConfig"
      :participantConfig="participantConfig"
      :groupList="groupList"
      @updateMixFormSuccess="updateMixFormSuccess"
      @close="nodeListPop"
    ></add-mix-form-popup>

    <!--创建下级目录-->
    <add-node-popup
      ref="nodeAddPopup"
      :mixFormId="$route.query.mixFormId"
      :stackList="stackList"
      :chargeUserConfig="chargeUserConfig"
      :participantConfig="participantConfig"
      @createNodeSuccess="createNodeSuccess"
      @close="nodeListPop"
    ></add-node-popup>
  </div>
</template>

<script>
  import {
    MIX_FORM_ITEM_TYPE_APPLY,
    MIX_FORM_ITEM_TYPE_ATTACHMENT, MIX_FORM_ITEM_TYPE_DASHBOARD, MIX_FORM_ITEM_TYPE_DATA,
    MIX_FORM_ITEM_TYPE_IMAGE, MIX_FORM_ITEM_TYPE_MEMO, MIX_FORM_ITEM_TYPE_MIX_FORM,
    MIX_FORM_ITEM_TYPE_NODE, MIX_FORM_ITEM_TYPE_VIEW
  } from "../../store/types";
  import {accurateFormatDate, arrayRemove, clone} from "../../../assets/js/Untis";
  import AddNodePopup from "../../component/mix_form/AddNodePopup";
  import AddMixFormPopup from "../../component/mix_form/AddMixFormPopup";

  export default {
    inject: ['reload'],

    beforeRouteLeave(to, form, next) {
      console.log('titleInfo', this.titleInfo)
      this.titleInfo.title = ''
      if (to.name !== "mixFormList" && to.name !== 'mixFormMiniAppNodeList') {
        // 如果不是回退到项目list页面，都放行。如果to是项目list页面，那就意味着是点击返回键，需要拦截
        // 如果返回到mixFormMiniAppNodeList，就说明是小程序，需要拦截
        next(true)
        return
      }
      if (this.chargeUserConfig.showContact) {

        this.chargeUserConfig.showContact = false
        next(false)

      } else if (this.participantConfig.showContact) {

        this.participantConfig.showContact = false
        next(false)

      } else if (this.stackList.length) {

        const visibleInfo = this.stackList.pop()
        visibleInfo.visible = false
        next(false)
      } else {
        if (to.name === 'mixFormMiniAppNodeList' && this.$store.getters.env === 'smallProgram') {
          this.$wx.miniProgram.navigateBack()
        } else {
          next(true)
        }
      }
    },

    components: {
      AddNodePopup,
      AddMixFormPopup
    },
    data() {
      return {
        titleInfo: {
          title: ''
        },
        stackList: [],
        loading: false,
        mixFormInfo: null,
        nodeList: [],
        applyItemMap: {},
        groupList: [],
        mixFormConfig: {
          visible: false,
          nodeId: ''
        },

        chargeUserConfig: {
          showContact: false
        },
        participantConfig: {
          showContact: false
        },
      }
    },
    created() {
      this.fetchMixFormDetail()
      this.fetchMixFormList()

      this.$store.dispatch('actionMixFormGroupList')
        .then(res => {
          this.groupList = res
        }).catch(console.error)
    },
    computed: {

      chargeUserName() {
        const user = this.$store.getters.userListMap[this.mixFormInfo.chargeUser]
        const extUser = this.$store.getters.extMap[this.mixFormInfo.chargeUser]
        return user ? user.nickname : extUser ? extUser.orgUserName : '无负责人'
      },
      participant() {
        const depList = this.$store.getters.depListMap,
          roleList = this.$store.getters.roleListMap,
          userList = this.$store.getters.userListMap,
          extList = this.$store.getters.extMap,
          labelList = this.$store.getters.extLabelMap

        const value = this.mixFormInfo.participant
        if (!value.depart) value.depart = []
        if (!value.role) value.role = []
        if (!value.member) value.member = []
        if (!value.external) value.external = []
        if (!value.externalTag) value.externalTag = []
        return [
          ...value.depart.map(depId => depList[depId] ? depList[depId].depName : ''),
          ...value.role.map(roleId => roleList[roleId] ? roleList[roleId].roleName : ''),
          ...value.member.map(userId => userList[userId] ? userList[userId].nickname : ''),
          ...value.external.map(userId => extList[userId] ? extList[userId].orgUserName : ''),
          ...value.externalTag.map(labelId => labelList[labelId] ? labelList[labelId].labelName : '')
        ].filter(item => !!item).join('、') || '无参与人'
      },
    },
    methods: {
      actionFormatTime(d) {
        return accurateFormatDate(d)
      },
      nodeListPop() {
        this.titleInfo.title = this.mixFormInfo.mixFormName
      },
      // 获取融合表详情
      fetchMixFormDetail() {
        this.$store.dispatch('actionMixFormOverview', {
          mixFormId: this.$route.query.mixFormId
        }).then(res => {
          this.mixFormInfo = res
          this.titleInfo.title = this.mixFormInfo.mixFormName
        }).catch(console.error)
      },

      // 获取融合表第一级目录list
      fetchMixFormList() {
        const toast = this.$toast.loading({message: '加载中...'})
        this.$store.dispatch('actionMixFormNodeList', {
          mixFormId: this.$route.query.mixFormId
        }).then(res => {
          this.nodeList = res

          res.forEach(node => {
            // 记录发起表单的item
            node.itemList.forEach(item => {
              if (item.itemType === MIX_FORM_ITEM_TYPE_APPLY) {
                this.applyItemMap[item.itemDetail.instanceId] = item
              }
            })
          })
          this.fetchNodeApplyItemStatus()
        }).catch(console.error)
          .finally(() => {
            toast.clear()
          })
      },
      // 获取节点挂载的我发起的表单的状态
      fetchNodeApplyItemStatus() {
        if (!Object.keys(this.applyItemMap)) {
          return
        }
        this.$store.dispatch('actionFormStatus', {
          instanceIdList: Object.keys(this.applyItemMap)
        }).then(res => {
          Object.keys(res).forEach(key => {
            const item = this.applyItemMap[key]
            if (item) {
              this.$set(item.itemDetail, 'status', res[key])
            }
          })
        })
      },
      onClickNode(node) {
        this.$store.dispatch('actionMixFormNodeItemList', {
          mixFormId: this.$route.query.mixFormId,
          nodeId: node.nodeId
        }).then(res => {
          node.itemList.splice(0, node.itemList.length, ...res)
          node.itemList.forEach(item => {
            if (item.itemType === MIX_FORM_ITEM_TYPE_APPLY) {
              this.applyItemMap[item.itemDetail.instanceId] = item
            }
          })
          this.fetchNodeApplyItemStatus()
        }).catch(console.error)

        if (this.$refs.nodeListPopup) {
          this.$refs.nodeListPopup.open(node)
        }
      },

      // 查看项目详情
      onClickMixFormDetail() {
        this.stackList.push(this.mixFormConfig)
        this.mixFormConfig.visible = true
      },

      // 添加下级目录
      onClickAddItem() {
        if (this.mixFormInfo.archived) {
          this.$toast.fail(`该${this.$store.getters.mix_form_name}已归档，暂时无法操作，请启用后操作`)
          return
        }
        if (this.$refs.nodeAddPopup) {
          this.$refs.nodeAddPopup.open({
            parentId: ''
          })
        }
      },

      // 创建下级目录成功
      createNodeSuccess(node) {
        this.fetchMixFormList()
      },

      // -----------------融合表操作
      deleteMixForm() {
        this.$dialog.confirm({
          title: '提示',
          message: '确定要删除吗?',
        })
          .then(() => {
            // on confirm
            const toast = this.$toast.loading({
              message: '加载中...'
            })
            this.$store.dispatch('actionMixFormDelete', {
              mixFormId: this.$route.query.mixFormId
            }).then(res => {
              const visibleInfo = this.stackList.pop()
              visibleInfo.visible = false
              this.$router.go(-1)
              this.$toast.success('删除成功')
            }).catch(console.error)
              .finally(() => {
                toast.clear()
              })
          })
          .catch(() => {
            // on cancel
          });
      },
      topMixForm() {
        this.$store.dispatch('actionMixFormTop', {
          mixFormId: this.mixFormInfo.mixFormId,
          top: this.mixFormInfo.top ? 0 : 1
        }).then(res => {
          this.mixFormInfo.top = this.mixFormInfo.top ? 0 : 1
          this.$toast.success('设置成功')
        }).catch(console.error)
      },

      archivedMixForm() {
        this.$store.dispatch('actionMixFormArchived', {
          mixFormId: this.mixFormInfo.mixFormId,
          archived: this.mixFormInfo.archived ? 0 : 1
        }).then(res => {
          this.mixFormInfo.archived = this.mixFormInfo.archived ? 0 : 1
          this.$toast.success('设置成功')
        }).catch(console.error)
      },

      // 编辑融合表
      editMixForm() {
        const visibleInfo = this.stackList.pop()

        if (this.$refs.addMixFormPopup) {
          this.$refs.addMixFormPopup.open({mixFormInfo: this.mixFormInfo})
        }

        setTimeout(() => {
          visibleInfo.visible = false
        }, 500)
      },

      // 更新融合表成功
      updateMixFormSuccess() {
        this.fetchMixFormDetail()
      },

      // 子目录被删除
      deleteNodeComplete(nodeId) {
        const node = this.nodeList.filter(node => node.nodeId === nodeId)[0]
        if (node) arrayRemove(this.nodeList, node)
      }
    },
    watch: {
      '$route.query.mixFormId'() {
        this.reload()
      }
    }
  }
</script>

<style lang="less">

  .mix-form-node-list-page {
    width: 100%;
    height: calc(100% - env(safe-area-inset-bottom));
    background-color: #F6F6F6;
    box-sizing: border-box;
    overflow: auto;

    .header {
      height: 60px;
      width: 100%;
      display: flex;
      align-items: center;
      padding: 0 10px;
      background-color: #fff;
      border-bottom: 1px solid #e6e6e6;

      > .iconfont {
        font-size: 18px;
        width: 24px;
        margin-left: 5px;
      }

      .info {
        width: calc(100% - 100px);
        display: flex;
        flex-direction: column;
        justify-content: center;
        border-left: 1px solid #e6e6e6;
        padding-left: 10px;
        height: 100%;
        margin: 0 5px;

        .name {
          width: 100%;
          color: #333333;
          font-size: 14px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-wrap: break-word;
          margin-bottom: 10px;
        }

        .detail {
          font-size: 12px;
          color: #3a8ee6;
        }
      }

      .last {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .archived-icon {
          margin-right: 10px;

          i {
            font-size: 34px;
            color: #05A971;
          }
        }

        .van-icon {
          width: 24px;
          font-size: 20px;
        }
      }
    }

    .content {
      padding-top: 10px;
      position: relative;

      .node-item {
        position: relative;
        margin: 0 10px 10px 40px;
        height: 50px;
        display: flex;
        align-items: center;
        padding-right: 10px;
        background-color: #fff;

        .color {
          width: 5px;
          height: 100%;
          margin-right: 10px;
        }

        .node-name {
          flex: 1;
          color: #333333;
          font-size: 14px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-wrap: break-word;
        }

        .van-icon {
          font-size: 16px;
          width: 20px;
        }

        &:before {
          width: 20px;
          height: 0;
          border-top: 1px dashed #bbb;
          position: absolute;
          left: -22px;
          top: 25px;
          content: "";
          display: block;
        }
      }

      &:after {
        width: 0;
        border-left: 1px dashed #bbb;
        position: absolute;
        left: 18px;
        bottom: 25px;
        top: 5px;
        content: "";
        display: block;
      }
    }

    .node-list-popup,
    .mix-form-detail-popup,
    .mix-form-edit-popup,
    .node-item-detail-popup {
      background-color: #F6F6F6;
    }
  }

  .mix-form-detail-popup {
    background-color: #F6F6F6 !important;

    .van-field__label {
      width: 60px;
      font-size: 13px;
    }

    .van-field__value {
      font-size: 13px;
    }

    .footer {
      background-color: #fff;
      position: absolute;
      bottom: calc(env(safe-area-inset-bottom));
      left: 0;
      right: 0;
      height: 50px;
      display: flex;
      justify-content: space-around;
      align-items: center;

      .btn-item {
        font-size: 14px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #7F8389;

        > div {
          margin-top: 5px;
          font-size: 12px;
        }

        i {
          font-size: 20px;
        }
      }
    }
  }

</style>